import { Review as ReviewInterface } from "../../others/review.interfaces"
import Img from "../Img"
import { HeadingSkeleton, ImgSkeleton, SpanSkeleton, TextBlockSkeleton } from "../skeletonTemplates/skeletons"

interface ReviewProps extends ReviewInterface {
    small?: boolean;
    skeleton?: boolean;
}

const Review = ({ author, description, review, profile, small, skeleton }: ReviewProps) => {
    if (skeleton) return <ReviewSkeleton />
    return (
        <div className="flex flex-col gap-0 max-w-sm text-gray-400">
            <div className="flex items-center gap-2 mb-1">
                <Img src={profile} alt={`${author}'s profile`} className="h-9 w-9 rounded-full" height={36} width={36} />
                <div className="flex flex-col gap-0">
                    {small ? <h4 className="!mb-0 text-gray-700">{author}</h4> : <h4 className="!mb-0 text-gray-700">{author}</h4>}
                    <span className="text-xs text-gray-500 -mt-1">{description}</span>
                </div>
            </div>
            <span className="text-sm">{review}</span>
        </div>
    )
}

export default Review

export const ReviewSkeleton = () => {
    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
                <ImgSkeleton />
                <HeadingSkeleton />
            </div>
            <SpanSkeleton />
            <TextBlockSkeleton />
        </div>
    )
}
